/* eslint-disable camelcase */
import React, { useMemo } from 'react';
import { MImage as Image } from '@shared/h5/components';
import { useMemoizedFn } from 'ahooks';
import classNames from 'classnames';

import styles from './index.module.scss';

/*
 * 6.0 会员icon
 * 1 精英版 黄冠  2 商务版 黄冠  3 VIP版 红色
 * 4 企业家 土金  5 招聘版 红色  6 企业招聘版 红色
 * 7 CXO 紫色  8 销售版 蓝色  10 企业销售版 蓝色
 * */
export const getMemberType = (memId: number) => {
  // 黄标会员
  if ([1, 2, 9].includes(+memId)) {
    return 1;
  }
  // 蓝标会员
  if ([3, 4, 5, 6, 7, 8, 10].includes(+memId)) {
    return 2;
  }
  // 5.0默认灰色，代表没买会员，6.0不再显示
  return 0;
};

export interface UserInfo {
  id?: number;
  avatar: string;
  mem_id?: number;
  trackable_token?: string;
}

export interface AvatarProps {
  size: number | `${number}`;
  contact: UserInfo;
  onClick?: () => void;
}

const defaultSrc = 'https://i9.taou.com/maimai/p/30264/2127_113_6pf7eBYYthmEmNz5-a160';

const Avatar: React.FC<AvatarProps> = ({ size, contact, onClick }) => {
  // 跳转到 profile 页，未登录会自动走登录逻辑
  const gotoProfile = useMemoizedFn((dstu: number | string, trackableToken: string, e) => {
    if (onClick) {
      onClick();
    }
    if (!dstu || !trackableToken) return;
    e.stopPropagation();
    const baseUrl = 'https://maimai.cn/profile/detail';
    window.open(`${baseUrl}?dstu=${dstu}&trackable_token=${trackableToken}&from=seo_page`, '_blank');
  });

  const placeholder = useMemo(() => {
    const sizeNumber = typeof size === 'string' ? parseInt(size, 10) : size;
    return sizeNumber > 40 ? 'blur' : 'empty';
  }, [size]);

  return (
    <div
      className={classNames(styles.avatar, {
        [styles.avatar_vip]: getMemberType(contact.mem_id) === 1,
        [styles.avatar_vip_p]: getMemberType(contact.mem_id) === 2,
      })}
      onClick={(e) => gotoProfile(contact.id, contact.trackable_token, e)}
      style={{ width: size, height: size }}
    >
      <div className={styles.avatar_wrap}>
        <Image
          width={size}
          height={size}
          alt='头像'
          src={contact.avatar || defaultSrc}
          placeholder={placeholder}
          blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNs2AQAAbgBNMqymOwAAAAASUVORK5CYII='
        />
      </div>
    </div>
  );
};

export default React.memo(Avatar);
